import z from 'zod';
/**
 * Position directly on the canvas/screen, using a top-left xy offset
 */
export const AbsolutePositionSchema = z.object({
    type: z.literal('absolute'),
    x: z.number(),
    y: z.number(),
});
/**
 * Position off-screen (hidden)
 */
export const OffScreenPositionSchema = z.object({
    type: z.literal('offScreen'),
});
/**
 * Position relative to a window element, given the bounding box for the element in that window
 */
export const WindowElementRelativePositionSchema = z.object({
    type: z.literal('windowElementRelative'),
    x: z.number(),
    y: z.number(),
    width: z.number(),
    height: z.number(),
});
/**
 * Position relative to the window, using a top-left xy offset
 */
export const WindowRelativePositionSchema = z.object({
    type: z.literal('windowRelative'),
    x: z.number(),
    y: z.number(),
});
export const PositionSchema = z.discriminatedUnion('type', [
    AbsolutePositionSchema,
    OffScreenPositionSchema,
    WindowElementRelativePositionSchema,
    WindowRelativePositionSchema,
]);
//# sourceMappingURL=position.js.map